module.exports = __webpack_public_path__ + "static/Bhavin-39898dbc4c8556f5edda35e2fe2118a4.png";